import { render, staticRenderFns } from "./icon--solid.vue?vue&type=template&id=53f68124&scoped=true"
import script from "./icon--solid.vue?vue&type=script&lang=js"
export * from "./icon--solid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f68124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f68124')) {
      api.createRecord('53f68124', component.options)
    } else {
      api.reload('53f68124', component.options)
    }
    module.hot.accept("./icon--solid.vue?vue&type=template&id=53f68124&scoped=true", function () {
      api.rerender('53f68124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/icon/icon--solid.vue"
export default component.exports